import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import * as React from "react";
import Icon from "../../../components/atoms/Icon";
import { StudentFollowSummary } from "./useFetchStudentFollowSummaries";

interface Props {
  summary: StudentFollowSummary;
}

// 生徒フォローサマリー 1 件のカード。生徒名・生成日時をヘッダに、サマリー期間（LIST-02）と
// 本文をボディに表示する（Figma node 8887:2528）。
// 生徒名は生徒個別ページへの導線を持たないプレーンテキスト表示とする（LIST-03。
// Figma の下線はリンクを連想させるため付けないことで確定・2026-08-24）
const StudentFollowSummaryCard = ({ summary }: Props) => {
  const period = `${format(parseISO(summary.startDate), "yyyy/MM/dd")} 〜 ${format(
    parseISO(summary.endDate),
    "yyyy/MM/dd",
  )}`;
  const generatedAt = format(
    parseISO(summary.generatedAt),
    "yyyy年MM月dd日 HH:mm",
  );

  return (
    <article className="box-border flex w-full flex-col gap-7 rounded-md border border-solid border-gray-400 bg-white p-7">
      <div className="flex items-center gap-3">
        <Icon
          name="icon-notice-user"
          color="pink"
          className="h-[2.8rem] w-[2.8rem]"
        />
        <div className="flex flex-wrap items-baseline gap-7">
          <p className="text-lg font-bold text-black">{summary.student.name}</p>
          <p className="text-md text-gray-900">{generatedAt}</p>
        </div>
      </div>
      <p className="whitespace-pre-wrap text-lg leading-[1.4] text-black">
        {`サマリー期間：${period}\n\n${summary.body}`}
      </p>
    </article>
  );
};

// 一覧はフィルタコンテキストの更新等で再レンダーされるため、summary（React Query の
// ページ参照により identity が安定）が変わらないカードの再レンダーをスキップする
export default React.memo(StudentFollowSummaryCard);
